<template>
  <div>
    <div class="home-head home-head-page">
      <TopHeader></TopHeader>
    </div>
    <div class="case case5 caseContain">
      <div class="caseTitle">
        <div class="container">
          <h3>应用案例</h3>
          <ul>
            <li class="caBg1">
              <a @click="gotoCase1" herf="#">
                <span>
                  <em>IDC服务商</em>
                  <i>IDC机房运维分析监控</i>
                </span>
              </a>
            </li>
            <li class="caBg2">
              <a @click="gotoCase2" herf="#">
                <span>
                  <em>
                    某上市
                    <b class="pSec"></b>零售企业
                  </em>
                  <i>
                    全业务可视化
                    <b class="pSec"></b>统计分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg6">
              <a @click="gotoCase3_1" herf="#">
                <span>
                  <em>
                    某交通管理部门
                    <b class="pSec"></b>
                  </em>
                  <i>交通流量业务可视化统计分析</i>
                </span>
              </a>
            </li>
            <li class="caBg3">
              <a @click="gotoCase4" herf="#">
                <span>
                  <em>运营商</em>
                  <i>
                    用户标签可视化
                    <b class="pSec"></b>聚合分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg4 active">
              <a @click="gotoCase3_2" herf="#">
                <span>
                  <em>某海事局</em>
                  <i>船舶追越分析</i>
                </span>
              </a>
            </li>
            <li class="caBg5">
              <a @click="gotoCase3_3" herf="#">
                <span>
                  <em>
                    智能电网
                    <b class="pSec"></b>运检
                  </em>
                  <i>
                    -大数据设备画
                    <b class="pSec"></b>像及应用
                  </i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="caseDetail">
        <div class="container">
          <div class="caseDetailS">
            <span class="caseImg">
              <span></span>
              <em>某海事局</em>
              <i>—船舶追越分析</i>
              <b></b>
            </span>
            <div class="caseCon">
              <div class="cPage1">
                <h4>项目背景</h4>
                <p>某海事局是交通运输部的直属单位，履行规划航道、水上交通安全监督管理、船舶及相关水上设施检验和登记、防止船舶污染和航海保障等行政管理和执法职责。</p>
                <p>
                  随着中国经济水平的飞速发展，在港口、海峡等重要水域的水上交通呈现出拥堵局面。管理通航秩序、通航环境、保障船只航行安全是海事局最重要的职责。
                  目前通过VHF频带上使用TDMA技术的通用船载AIS设备发出的速度、方向、GIS位置等信息，海事部门将接收到船只航行中的相关报文，并捕捉分析船只的“追越行为”，从而监管船只航行状态，保障“超车”动作在安全范围内有序进行
                </p>
                <p>然而，要实现对船只的追越状况进行捕捉和分析，生成日常追越报表，同时进行追越船只的实时捕捉及预警，管理人员面临着庞大的数据量以及复杂的算法等问题。</p>
              </div>
              <div class="cPage2">
                <h4>解决方案</h4>
                <h5>应用场景</h5>
                <div class="cpCon cpCon1">
                  <div class="left">
                    <i></i>生成日常报表
                  </div>
                  <div class="right">
                    <p>
                      <i>1</i>先对庞大的全量数据进行筛选和结构化处理，再过滤出过去某一时间段内发生过追越的船只
                    </p>
                    <p>
                      <i>2</i>捕捉追越和被追越船只的编号、经纬度，速度等关键信息
                    </p>
                    <p>
                      <i>3</i>统计出船只发生追越的时间段及追越次数，便于管理者回顾
                    </p>
                  </div>
                </div>
                <div class="cpCon cpCon2">
                  <div class="left">
                    <i></i>实时捕捉追越
                  </div>
                  <div class="right">
                    <p>将算法应用在流式数据，实时捕捉正在追越的船只，发出预警并可视化呈现追越船只在指定区域的分布</p>
                  </div>
                </div>
                <div class="cpCon cpCon3">
                  <div class="left">
                    <i></i>追越预测预警
                  </div>
                  <div class="right">
                    <p>预测未来即将发生的追越，发出预警并规避潜在风险</p>
                  </div>
                </div>
                <h5>技术实现</h5>
                <div class="cpCon cpCon4">
                  <p>
                    <i>挑战1</i>业务逻辑特殊且复杂，需要结构化思维
                  </p>
                  <p>
                    <i>挑战2</i>数据量庞大，对流式数据的结构化以及对全量数据的存储、低延时查询上有难度
                  </p>
                  <p>
                    <i>挑战3</i>判断追越的算法实现难度大且需专业人员持续维护和优化
                  </p>
                </div>
              </div>
              <div class="cPage3">
                <h4>目标与价值</h4>
                <table>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>应用场景上
                        </p>
                      </td>
                      <td>
                        <p>深入契合业务需求，将追越条件转化为数学逻辑，生成日常报表、实时捕捉追越。</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>大数据量上
                        </p>
                      </td>
                      <td>
                        <p>发挥平台价值，快速准确地实现数据预处理、分析及存储。</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>算法转化上
                        </p>
                      </td>
                      <td>
                        <p>无缝对接数学逻辑，实现从概念到技术上的转化</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>业务价值上
                        </p>
                      </td>
                      <td>
                        <p>通过业务到算法，算法回归业务的概念，实现追越结果的输出和追越分布的可视化呈现</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <i></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
.case {
  color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>

<script>
import TopHeader from "../../../common/compoments/TopHeader";
import Footer from "../components/Footer.vue";
export default {
  name: "case3-2",
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {
    this.$nextTick().then(
      function() {
        var loginR = document
          .getElementsByClassName("right-selection")[0]
          .getElementsByTagName("div");
        loginR[0].className = "new_login new_login_bcon3";
        loginR[1].className = "new_login new_login_bcon4";
      }.bind(this)
    );
  },
  methods: {
    gotoAbout: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "about" });
    },
    gotoScenarios: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "scenarios" });
    },
    gotoCase1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case1" });
    },
    gotoCase2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case2" });
    },
    gotoCase3_1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_1" });
    },
    gotoCase3_2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_2" });
    },
    gotoCase3_3: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_3" });
    },
    gotoCase4: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case4" });
    }
  }
};
</script>
